import gql from "graphql-tag";

const createAppConfigReminder = gql`
  mutation(
    $daysAddedDefaultInDeadline: Int!
    $remindBefore: Int!
    $module: String!
  ) {
    createAppConfigReminder(
      data: {
        daysAddedDefaultInDeadline: $daysAddedDefaultInDeadline
        remindBefore: $remindBefore
        module: $module
      }
    ) {
      id
      module
      daysAddedDefaultInDeadline
      remindBefore
      updatedAt
      createdAt
    }
  }
`;

const updateAppConfigReminder = gql`
  mutation updateAppConfigReminder(
    $daysAddedDefaultInDeadline: Int!
    $remindBefore: Int!
    $id: ID!
  ) {
    updateAppConfigReminder(
      data: {
        daysAddedDefaultInDeadline: $daysAddedDefaultInDeadline
        remindBefore: $remindBefore
      }
      id: $id
    ) {
      id
      daysAddedDefaultInDeadline
      remindBefore
      updatedAt
      createdAt
    }
  }
`;

// const getAppConfigReminderModulesName = gql`
//     getAppConfigReminderModulesName(
//       module
//     ) {
//       module
//     }
//   }
// `;

const getAppConfigReminderModulesName = gql`
  query {
    getAppConfigReminderModulesName
  }
`;

export default {
  createAppConfigReminder,
  updateAppConfigReminder,
  getAppConfigReminderModulesName,
};
